// extracted by mini-css-extract-plugin
export var box = "_3u-0";
export var check = "_3u-1";
export var checkboxButton = "_3u-6";
export var checkboxGroup = "_3u-5";
export var disabled = "_3u-7";
export var ghost = "_3u-9";
export var input = "_3u-2";
export var label = "_3u-4";
export var normal = "_3u-8";
export var uncheck = "_3u-3";